// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.dc9b0443d',
  revision: 'dc9b0443d',
  branch: 'develop',
  date: 'Fri, 25 Sep 2026 13:50:33 GMT'
};